import ApiService from 'Services/ApiService'

export default {
    list(query) {
        return ApiService.get(`/issues`, query)
    },
    get(id) {
        return ApiService.get(`issues/${id}`)
    },
    store(issue) {
        return ApiService.post('issues', issue)
    },
    update(issue) {
        return ApiService.put(`issues/${issue.id}`, issue)
    },
    delete(id) {
        return ApiService.delete(`issues/${id}`)
    }
}